var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShortlink2 = function SvgShortlink2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shortlink2_svg2__a",
    x1: -43.89,
    x2: 74.7,
    y1: 97.65,
    y2: -9.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#shortlink2_svg2__a",
    id: "shortlink2_svg2__b",
    x1: -37.17,
    x2: 81.42,
    y1: 105.12,
    y2: -1.61
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#shortlink2_svg2__a",
    id: "shortlink2_svg2__c",
    x1: -39.37,
    x2: 79.22,
    y1: 102.67,
    y2: -4.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#shortlink2_svg2__a",
    id: "shortlink2_svg2__d",
    x1: 65.96,
    x2: 184.55,
    y1: 219.71,
    y2: 112.98
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#shortlink2_svg2__a",
    id: "shortlink2_svg2__e",
    x1: 0.81,
    x2: 119.39,
    y1: 147.31,
    y2: 40.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#shortlink2_svg2__a",
    id: "shortlink2_svg2__f",
    x1: -0.71,
    x2: 117.88,
    y1: 145.63,
    y2: 38.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#shortlink2_svg2__a",
    id: "shortlink2_svg2__g",
    x1: 0.05,
    x2: 118.64,
    y1: 146.48,
    y2: 39.75
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M32.86 41.15c5.44 5.4 13.68-2.85 8.29-8.29L28.42 20.13a5.86 5.86 0 0 0-8.29 0 5.86 5.86 0 0 0 0 8.29z",
    style: {
      fill: "url(#shortlink2_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.91 62.39a5.86 5.86 0 0 0-4.16-7.17L7.36 50.59a5.86 5.86 0 0 0-7.17 4.16 5.86 5.86 0 0 0 4.16 7.17l17.39 4.63c3.04.84 6.35-1 7.17-4.16",
    style: {
      strokeWidth: 0,
      fill: "url(#shortlink2_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.22 24.76c2.04 7.42 13.26 4.37 11.32-3.01L61.91 4.36A5.86 5.86 0 0 0 54.74.2a5.86 5.86 0 0 0-4.16 7.17l4.63 17.39Z",
    style: {
      strokeWidth: 0,
      fill: "url(#shortlink2_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.84 126.64-83.68-21.26a5.59 5.59 0 0 0-5.32 1.46 5.59 5.59 0 0 0-1.46 5.33l21.27 83.67c1.03 4.7 7.83 5.72 10.19 1.51l12.3-20.37 14.55 11.36c6.98 5.45 16.96 4.83 23.22-1.43s6.87-16.24 1.43-23.22l-11.36-14.55 20.37-12.3c4.2-2.35 3.19-9.16-1.51-10.19Z",
    style: {
      strokeWidth: 0,
      fill: "url(#shortlink2_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.13 100.43-11.6 11.6c-7.81 7.81-20.52 7.81-28.33 0a19.9 19.9 0 0 1-5.87-14.16c0-5.35 2.09-10.38 5.87-14.16l11.6-11.6a5.86 5.86 0 0 0 0-8.29 5.86 5.86 0 0 0-8.29 0l-11.6 11.6c-5.99 5.99-9.29 13.96-9.3 22.45 0 8.48 3.3 16.46 9.3 22.45 6 6 13.97 9.3 22.45 9.3s16.45-3.3 22.45-9.3l11.6-11.6a5.86 5.86 0 0 0 0-8.29 5.86 5.86 0 0 0-8.29 0Z",
    style: {
      strokeWidth: 0,
      fill: "url(#shortlink2_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.32 78.81c5.99-5.99 9.29-13.96 9.3-22.45 0-8.48-3.3-16.46-9.3-22.45-12.38-12.38-32.52-12.38-44.9 0l-11.6 11.6a5.86 5.86 0 0 0 0 8.29 5.86 5.86 0 0 0 8.29 0l11.6-11.6c7.81-7.81 20.52-7.81 28.33 0 3.78 3.78 5.86 8.81 5.86 14.16s-2.09 10.38-5.86 14.16l-11.6 11.6a5.86 5.86 0 0 0 0 8.29 5.86 5.86 0 0 0 8.29 0l11.6-11.6Z",
    style: {
      strokeWidth: 0,
      fill: "url(#shortlink2_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.43 56.8a5.86 5.86 0 0 0-8.29 0L72.97 72.97 56.79 89.15a5.86 5.86 0 0 0 0 8.29c1.14 1.14 2.64 1.71 4.14 1.71s3-.57 4.14-1.71l16.18-16.18 16.17-16.18a5.86 5.86 0 0 0 0-8.29Z",
    style: {
      strokeWidth: 0,
      fill: "url(#shortlink2_svg2__g)"
    }
  }));
};
export default SvgShortlink2;